import { render } from "./FilterbarAnalyticsCorrectness.vue?vue&type=template&id=b2271a86&scoped=true"
import script from "./FilterbarAnalyticsCorrectness.vue?vue&type=script&lang=js"
export * from "./FilterbarAnalyticsCorrectness.vue?vue&type=script&lang=js"

import "@/css/components/filterbar-analytics-correctness.css?vue&type=style&index=0&id=b2271a86&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2271a86"]])

export default __exports__